module.exports = __webpack_public_path__ + "img/icon_trade_contract_trade_result_contract.5d6039a7.svg";